module.exports = __webpack_public_path__ + "img/hmc-logo.b9379672.png";